import { render, staticRenderFns } from "./ToastsBasic.vue?vue&type=template&id=2c122794"
import script from "./ToastsBasic.vue?vue&type=script&lang=js"
export * from "./ToastsBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports